import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const underThirtyMothersChildrenEligibleData = atom({
  key: "underThirtyMothersChildrenEligibleData",
  default: "eligibleOnOwnChild",
  effects_UNSTABLE: [ocPersistAtom],
});
